/**
 * Skeleton Component
 *
 * Simple loading skeleton for placeholder content.
 * Used in approval workflow components.
 */

import {cn} from '@matic/lib/utils/cn';

type SkeletonProps = {
  className?: string;
};

export function Skeleton({className}: SkeletonProps) {
  return (
    <div className={cn('animate-pulse rounded-md bg-neutral-200', className)} />
  );
}
